export default class SkinLibrary {
    skins = {};

    constructor(library) {
        this.library = library;
        this.game = library.game;
        this.getLibrary();
        this.skinComponent = null;
    }

    getLibrary = () => {
        this.game.gameApi.getLibrary('Skin');
    };

    receiveLibrary = (skinLibrary) => {
        skinLibrary.forEach((skinData) => {
            this.skins[skinData.id] = skinData;
        });
        this.setComponentValue();
    };

    setComponentValue = () => {
        this.skinComponent && this.skinComponent.setSkin();
    }

}
